





































// vendor
import { defineComponent } from "@vue/composition-api";
// project
import { GlobalAdd } from "@/components.nav/global-add";
import { LangToggle } from "@lang";
import { HelpButton } from "@help";
import { UserButton } from "@user";
import { AbsBox } from "@ui";

export default defineComponent({
	props:{
		menuState:{
			type:Boolean,
			default:true
		}
	},
	components: {
		AbsBox,
		UserButton,
		GlobalAdd,
		LangToggle,
		HelpButton,
	},
	setup(props, context){

		const openMenu = () => {
			context.emit("open-menu");
		};

		return {
			openMenu
		}
	}
});

